import { User } from "interfaces/user";

export const showAds = (user?: User | null, testAd: boolean = false) => {
  if (!testAd) return true;
  // Eric or Hadrien
  const shouldUserSeeAds =
    user?.uid &&
    ["hha27gXdrubZAiCR5zlFtG7ojQ12", "x8KRLkZLAdMgFIWrF2iriQGkwat1"].includes(
      user?.uid,
    );
  if (shouldUserSeeAds) return true;
  return false;
};
